import axiosInstance from "@/axiosInstance";

const state = () => ({
  packages: [],
  items: [],
  deletedItems: [],
  productsLoaded: false,
});

const mutations = {
  SET_PACKAGES(state, packages) {
    state.packages = packages;
  },
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_DELETED_ITEMS(state, deletedItems) {
    state.deletedItems = deletedItems;
  },
  SET_PRODUCTS_LOADED(state, loaded) {
    state.packagesLoaded = loaded;
  },
  CLEAR_PRODUCTS_DATA(state) {
    state.packages = [];
    state.items = [];
    state.productsLoaded = false;
  },
};

const actions = {
  async fetchProductsData({ state, commit }) {
    if (state.productsLoaded) return;
    try {
      const [packageRes, productRes, deletedProductRes] = await Promise.all([
        axiosInstance.get("packages/"),
        axiosInstance.get("items/"),
        axiosInstance.get("deleted-items/"),
      ]);
      commit("SET_PACKAGES", packageRes.data);
      commit("SET_ITEMS", productRes.data);
      commit("SET_DELETED_ITEMS", deletedProductRes.data);
      commit("SET_PRODUCTS_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  },
  // async fetchPositionInfo(_, slug) {
  //     try {
  //         const response = await axiosInstance.get(`onboard/positions/${slug}/`);
  //         return response.data;
  //     } catch (error) {
  //         console.error("Failed to fetch position by slug:", error);
  //         throw error;
  //     }
  // }
};

const getters = {
  getPackages: (state) => state.packages,
  getItems: (state) => state.items,
  getDeletedItems: (state) => state.deletedItems,
  isProductsLoaded: (state) => state.productsLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};